var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6C4EB0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,27c2-2.5,5.6-3.7,8.1-3.8c7-0.1,10,8.7,10.2,12.2l3.3,1C77.5,25.7,70.8,20,64.5,20 c-6,0-11.5,4.4-13.7,10.8c-3,8.6-1,16.8,2.7,23.4c-0.3,0.4-0.5,1.2-0.5,1.9c0.1,2,1.7,3.6,3.7,3.6h0.1c2-0.1,3.6-1.8,3.6-3.8 c0,0,0-0.1,0-0.1c0-2-1.7-3.6-3.7-3.6h-0.1c-0.1,0-0.3,0-0.5,0.1c-2.7-4.6-3.8-9.5-3.4-14.9C53,33.4,54.3,29.9,56.6,27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,64.3c2.2,3.3,6.6,5.4,11.5,5.4c1.3,0,2.7-0.1,4-0.4C64.9,67.7,71.4,62.5,75,55l0-0.1 c1.9-0.2,3.4-1.8,3.3-3.9c-0.1-2-1.7-3.6-3.7-3.6h-0.1c-2.1,0.1-3.6,1.8-3.6,3.9c0.1,1.1,0.5,1.9,1.1,2.5 c-2.3,4.5-5.7,7.8-10.9,10.5c-3.5,1.8-7.2,2.5-10.7,2c-3-0.4-5.3-1.8-6.8-4c-2.1-3.3-2.3-6.8-0.6-10.4c1.3-2.6,3.3-4.4,4.6-5.4 c-0.3-0.9-0.7-2.3-0.9-3.4C37,50.3,38,59.8,40.9,64.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,62.9c2-4,1.8-10.6-3.2-16.3l0,0.1c-5-6-12.5-9.3-20.9-9.3h-1.1c-0.6-1.2-1.8-2-3.3-2h-0.1 c-2.1,0-3.6,1.8-3.6,3.9c0.1,2,1.7,3.6,3.7,3.6h0.2c1.4-0.1,2.7-1,3.3-2.3h1.2c5,0,9.8,1.5,14.1,4.4c3.3,2.2,5.7,5.1,7,8.6 c1.2,2.8,1.1,5.6-0.1,7.9c-1.9,3.6-5,5.5-9.1,5.5c-2.6,0-5.1-0.8-6.5-1.4c-0.8,0.7-2.1,1.7-3,2.4c2.9,1.3,5.8,2.1,8.6,2.1 C83.4,70,88.1,66.4,89.9,62.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/Redux.229ce102f105b10e8359f5211ce77593.svg";
export { ForwardRef as ReactComponent };